
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Work.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/BaseEnvironments/Work.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 02/04/24, 15:00;
 * Updated at: 02/04/24, 08:48;
 *
 *
 */

import { getModule, addModule } from '../Utility/ModuleUtility';
import {Progetti} from "../Modules/Progetti";
import {Clienti} from "../Modules/Clienti";
import {Fasi} from "../Modules/Fasi";
import {GraficaFF} from "../Modules/GraficaFF";
import {Fornitori} from "../Modules/Fornitori";
import {OggettoConfig} from "../../app/shared/_services/dynamic-crud.service";
function Tempi() {
  var OBJ: OggettoConfig = {
    HasAddList: {func:()=>{return true}},//da usare come hideif

    Id: "tempi",
    listTitle: "Tempi",
    DisableEdit:true,
    RestRoute: '/progetti/tempi',
    ListResponseHasData: true,
    GetResponseHasData: false,
    ListDefaultFilter: {},
    OnSaveMap: (x) => { { return x } },
    MenuItems: [

    ],
    campi: [
    ],
    Azioni: [
    ],
    Headers: [
      { nome: 'Data', oggetti: ['data'], inputType: 'date' },
      { nome: 'Durata (H)', oggetti: ['durata'] },
      { nome: 'Attività', oggetti: ['task'] },
    ],
    Filters: [],
  }
  return OBJ;
}
var Environment = () => {
  var env: any = {
    theme: 'light',
    baseUrl: '/interventi/interventi',
    Modules: {
      "Prima_Nota": true,
    },

    logoPath:'assets/images/logo_transparent_background.png',
    langSuffix: '_Rossetti.json',
    TaskAddon: {
      hideChecklistFasi:true,
      hideGantt:true,
    },
    Cruds:[Tempi()],
    Personale:{
      Tabs:[
        { id: 'info', tipo: 'template', titolo: 'Anagrafica', component: 'Edit' },
        { id: 'files', tipo: 'template', titolo: 'Files', component: 'Files', hideif: { fieldnotexist: 'id' } },
        { id: 'cdl', titolo: 'Tempi', tipo: 'crud', crud: 'tempi', hideif: { fieldnotexist: 'persona_id' } },
      ]
    },

    ProgettiAddon:{
      HideVoci:true,
      hideGeneraFattura:true,
      lavorato:false,
      hideImpostaDate:true,
      badges: [
        { nome: 'Non Approvati', oggetti: ['nonAccettate'], },
        { nome: 'Approvati', oggetti: ['Accettate'], },
        { nome: 'Completati', oggetti: ['chiuse'] },
        { nome: 'Annullati', oggetti: ['annullate'] },
        { nome: 'Totale Offerto', oggetti: ['offerto'], },
        { nome: 'Totale Accettato', oggetti: ['accettato'] },
        { nome: 'Valore Lavorato', oggetti: ['lavorato'] },
      ],
    },
    Menu: [
      {
        module: "Personale",
        path: "/listautenti/personale",
        title:'menu.PersonaleLabel',
        icon: "far fa-user",
        capacita: ["menu-persone"]
      },
    ]
  };

  env = addModule(Progetti(), env);
  env = addModule(Fornitori(),env);
  env = addModule(Fasi(),env);
  env = addModule(Clienti(),env);
  env = addModule(GraficaFF(), env);
  env.ClientiAddOn = {
    ...env.ClientiAddOn,
    referenti:true
  }
  return env;
};

export var FullEnv = () => {
  var env: any = {};
  env = getModule(Environment());

  env.ProgettiAddon.badges = [
    { nome: 'Non Approvati', oggetti: ['nonAccettate'], },
    { nome: 'Approvati', oggetti: ['Accettate'], },
    { nome: 'Completati', oggetti: ['chiuse'] },
    { nome: 'Annullati', oggetti: ['annullate'] },
    { nome: 'Totale Offerto', oggetti: ['offerto'], },
    { nome: 'Totale Accettato', oggetti: ['accettato'] },
    { nome: 'Valore Lavorato', oggetti: ['lavorato'] },
  ];
  env.ProgettiAddon.CampiOfferta = [
    {
      modificabile: true,
      nome: 'Oggetto:',
      oggetti: ['oggetto'],
      inputType: 'text',
      titleClass: 'control-label col-form-label',
      class: 'col-lg-3',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'Codice Progetto:',
      oggetti: ['codice'],
      inputType: 'text',
      titleClass: 'control-label col-form-label',
      class: 'col-lg-3',
      placeholder: 'Codice Progetto:',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'Offerta.Responsabile',
      oggetti: ['manager'],
      inputType: 'singleDropdown',
      source: 'managers',
      internalOutput: 'managerObject',
      OnFilter: 'filtroManager',
      OnChange: 'OnManagerChange',
      placeholder: 'Seleziona',
      settings: {
        singleSelection: true,
        closeDropDownOnSelection: true,
        singleOutput: true,
        idField: 'id',
        textField: 'fullName',
        searchPlaceholderText: "inserire almeno 3 caratteri",
        allowSearchFilter: true,
        allowRemoteDataSearch: true,
      },
      titleClass: 'control-label col-form-label',
      class: 'col-lg-3',
      visibleifProhibited: true
    },
    {
      prevDivClass: "col-md-12",
      modificabile: true,
      nome: 'Offerta.Creazione',
      oggetti: ['data_creazione'],
      inputType: 'date',
      titleClass: 'control-label col-form-label',
      class: 'col-md-3',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'Offerta.Offerta',
      oggetti: ['data_emissione'],
      inputType: 'date',
      titleClass: 'control-label col-form-label',
      class: 'col-md-3',
      visibleifProhibited: true
    },
    {
      modificabile: true,
      nome: 'Offerta.Accettazione',
      oggetti: ['data_accettazione'],
      inputType: 'date',
      titleClass: 'control-label col-form-label',
      class: 'col-md-3',
      visibleifProhibited: true
    },
    // {
    //   modificabile: true,
    //   nome: 'Offerta.Conferma',
    //   oggetti: ['data_conferma'],
    //   inputType: 'date',
    //   titleClass: 'control-label col-form-label',
    //   class: 'col-md-3',
    //   visibleifProhibited: true
    // },
    {
      prevDivClass: "col-md-12",
      modificabile: true,
      nome: 'Note',
      oggetti: ['note'],
      inputType: 'textarea',
      titleClass: 'control-label col-form-label',
      class: 'col-md-6',
      visibleifProhibited: true
    },
    {

      modificabile: true,
      nome: 'Completato:',
      oggetti: ['chiuso'],
      inputType: 'checkbox',
      titleClass: 'control-label col-form-label',
      class: 'col-md-1',
      visibleifProhibited: true,
    },
    {
      modificabile: true,
      nome: 'Annullato:',
      oggetti: ['annullato'],
      inputType: 'checkbox',
      titleClass: 'control-label col-form-label',
      class: 'col-md-1',
      visibleifProhibited: true,
    },
    {
      modificabile: true,
      nome: 'Data Annullamento:',
      oggetti: ['dataAnnullato'],
      inputType: 'date',
      titleClass: 'control-label col-form-label',
      class: 'col-md-2',
      visibleifProhibited: true,
    },




  ];
  return env;
};

export var environment: any = FullEnv();
// var Environment = () => {
//   var env= {
//     baseUrl: '/progetti/progetti',
//     Modules: {
//       Progetti: true,
//       Interventi: true,// fasi offerta
//       Stampe: true,
//       Prodotti: true,
//     },
//     Menu: [
//       {
//         title: "Menu",
//         class: "has-arrow",
//         label: "Menu",
//         extralink: true
//       },
//       {
//         module: "Personale",
//         path: "/listautenti/personale",
//         title:'menu.PersonaleLabel',
//         icon: "far fa-user",
//         capacita: ["menu-persone"]
//       },
//       {
//         module: "Clienti",
//         path: "/listautenti/aziende",
//         title:'menu.clienti',
//         icon: "mdi mdi-account-multiple",
//         capacita: ["menu-clienti"]
//       },
//       {
//         module:"Progetti",
//         path: "progetti/progetti",
//         title: 'menu.progetti',
//         icon: "mdi mdi-calendar-multiple-check",
//         capacita: ["menu-progetti"]
//       },
//       {
//         module: "Prodotti",
//         path: "progetti/prodotti",
//         title: 'menu.ProdottiLabel',
//         icon: "mdi mdi-barcode-scan",
//         capacita: ["menu-prodotti"]
//       },
//     ]
//   };
//
//   return env;
// }
//
// export var environment =  getModule(Environment());
